import { render, staticRenderFns } from "./GroupEdit.vue?vue&type=template&id=b6555fd6"
import script from "./GroupEdit.vue?vue&type=script&lang=js"
export * from "./GroupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports